import { Colors, Services, getServiceNameViaPoint, getServicePathToAPI, joinURLPath, reportManagerQueueFinalStatuses, reportManagerRecurrentFinalStatuses } from '@sigma-frontend-libs/commons'
import { EReportTaskQueueStatus, EReportTaskRecurrentStatus } from '@sigmasms/shared-types'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

export default {
  name: 'Cancel',

  props: {
    value: {
      type: Object,
      default: undefined
    },

    service: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      showDialog: false
    }
  },

  computed: {
    isFinalStatus() {
      const status = this.value?.status

      switch (this.service) {
        case Services['report-manager/queue']: return reportManagerQueueFinalStatuses.includes(status)
        case Services['report-manager/recurrent']: return reportManagerRecurrentFinalStatuses.includes(status)
        default: return false
      }
    },

    disabled() {
      if (this.loading) {
        return true
      }

      const status = this.value?.status

      if (typeof status === 'undefined') {
        return true
      }

      return this.isFinalStatus
    },

    serviceNameViaPoint() {
      return getServiceNameViaPoint(this.service)
    }
  },

  methods: {
    /**
     * Возвращает статус отмены для текущего сервиса report-manager.
     *
     * @returns {string}
     */
    getCancelledStatus() {
      if (this.service === Services['report-manager/recurrent']) {
        return EReportTaskRecurrentStatus.cancelled
      }

      return EReportTaskQueueStatus.cancelled
    },

    /**
     * Синхронизирует локальную карточку ответом сервера после отмены.
     *
     * @param {Record<string, unknown> | undefined} data
     * @returns {void}
     */
    syncLocalValue(data) {
      if (!data || typeof data !== 'object' || !this.value) {
        return
      }

      for (const key in data) {
        this.$set(this.value, key, data[key])
      }
    },

    /**
     * Отменяет задание и сразу обновляет локальную карточку,
     * чтобы состояние и действия не отставали от сервера.
     *
     * @returns {Promise<void>}
     */
    async cancel() {
      if (this.disabled || !this.value?.id) {
        return
      }

      try {
        this.loading = true
        const payload = { status: this.getCancelledStatus() }
        const pathToAPI = getServicePathToAPI(this.service)
        const data = await request.update(joinURLPath(pathToAPI, this.value.id), { body: payload })
        if (data?.status === payload.status) {
          this.syncLocalValue(data)
          this.addSnackbar({
            text: this.getTranslate(`${this.serviceNameViaPoint}.snackbars.${payload.status}`),
            type: Colors.success
          })
          this.showDialog = false
        } else {
          throw new Error(this.getTranslate(`${this.serviceNameViaPoint}.errors.cancel.failed`))
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
